import * as Scrivito from "scrivito";
import TableCellWidget from "../TableCellWidget/TableCellWidgetClass";

export const AddMoreColumns = Scrivito.connect(
  ({ attribute, rows, summaryRows }) => {
    if (!Scrivito.isInPlaceEditingActive()) {
      return null;
    }

    const currentRowCells = rows.map((row) => row.get(attribute));
    const currentSummaryCells = summaryRows.map((summaryRow) =>
      summaryRow.get(attribute)
    );

    return (
      <div className="table-add-column-wrapper">
        <div className={"table-add-column"}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              rows.forEach((row, idx) => {
                const updatedAttributes = {};
                updatedAttributes[attribute] = [
                  ...currentRowCells[idx],
                  new TableCellWidget({}),
                ];
                row.update(updatedAttributes);
              });

              summaryRows.forEach((summaryRow, idx) => {
                const updatedAttributes = {};
                updatedAttributes[attribute] = [
                  ...currentSummaryCells[idx],
                  new TableCellWidget({}),
                ];
                summaryRow.update(updatedAttributes);
              });
            }}
            className="btn bg-white mb-2"
            title="add column to the end of the table"
          >
            <i className="las la-plus text-blue"></i>
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              // eslint-disable-next-line no-alert
              const confirmed = window.confirm(
                "Do you want to delete the last column from the table? This action cannot be undone."
              );
              if (!confirmed) return;

              rows.forEach((row, idx) => {
                const updatedAttributes = {};
                updatedAttributes[attribute] = currentRowCells[idx].slice(
                  0,
                  currentRowCells[idx].length - 1
                );
                row.update(updatedAttributes);
              });

              summaryRows.forEach((summaryRow, idx) => {
                const updatedAttributes = {};
                updatedAttributes[attribute] = currentSummaryCells[idx].slice(
                  0,
                  currentRowCells[idx].length - 1
                );
                summaryRow.update(updatedAttributes);
              });
            }}
            className="btn bg-orange"
            title="delete last column from the table"
          >
            <i className="las la-trash text-white"></i>
          </a>
        </div>
      </div>
    );
  }
);
